import React from "react"

import { styled } from "@mui/material/styles"
import { Tooltip, TooltipProps, tooltipClasses } from "@mui/material"

export type Severity = "error" | "warning" | "info"
export const borderColor = (severity: Severity | "primary") => {
  switch (severity) {
    case "error":
      return "#F8D0D0"
    case "warning":
      return "#FFDAAE"
    default:
      return "#E9ECF0"
  }
}

export const backgroundColor = (severity: Severity | "primary") => {
  switch (severity) {
    case "error":
      return "#FFF8F8"
    case "warning":
      return "#FFF7EE"
    default:
      return "#FFFFFF"
  }
}

interface FileItemTooltipProps {
  severity: Severity
}

export const FileItemTooltip = styled(({ className, ...props }: TooltipProps & FileItemTooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }}></Tooltip>
))(({ severity }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#FFFFFF",
    fontSize: "large",
    "&::before": {
      border: "1px solid #F8D0D0"
    }
  },
  [`& .${tooltipClasses.tooltip}`]: {
    color: "#42526E",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 15px #00000026",
    border: `1px solid ${borderColor(severity)}`,
    opacity: 1,
    letterSpacting: "0px",
    textAlign: "left",
    font: "normal normal normal 10px/16px Inter",
    padding: "0px"
  }
}))
